import { FormAccordion } from '@strata/react-form-section';
import { useEffect, useRef } from 'react';

import { type FormSection } from 'store/intakeForm/intakeFormSchema';

/** Focus input on active section open */
export const useInputFocusRef = (isOpen: boolean, activeSection: number, section: FormSection) => {
    const inputRef = useRef<HTMLInputElement & HTMLTextAreaElement>(null);
    useEffect(() => {
        if (isOpen && activeSection === section) {
            // Need to set timeout when focusing on accordion section open
            setTimeout(() => inputRef.current?.focus(), FormAccordion.AnimateDuration);
        }
    }, [isOpen, activeSection, section]);
    return inputRef;
};
